<script setup lang="ts">
import { GpFadeTransition } from '@gportal/uikit';
import type { ServiceError } from 'gpcore-apikit/grpc/types';

const { isLoading = false, error = null } = defineProps<{
  isLoading?: boolean;
  error?: Error | ServiceError;
  isEmpty?: boolean;
}>();
</script>

<template>
  <GpFadeTransition name="fade" mode="out-in">
    <template v-if="isLoading">
      <slot name="loading"></slot>
    </template>

    <template v-else-if="error">
      <slot name="error" :error="error"></slot>
    </template>

    <template v-else-if="isEmpty">
      <slot name="empty"></slot>
    </template>

    <template v-else>
      <slot></slot>
    </template>
  </GpFadeTransition>
</template>

<style scoped></style>
